export class FailedToResolveExistingShelter extends Error {}
